import { ApplicationConfig } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'
import { routes } from './app.routes'
import { provideTranslateService, TranslateModuleConfig } from '@ngx-translate/core'
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc'
import { ToastService } from '@siemens/ix-angular/standalone'
import { environment } from '../environments/environment'
import { AppVersion } from '../environments/app.version'

const oauthStorageFactory = () => localStorage

export const provideTranslation = (): TranslateModuleConfig => ({
  fallbackLang: 'en',
  loader: provideTranslateHttpLoader({
    prefix: './assets/i18n/',
    suffix: `.json?v=${AppVersion.buildTimestamp}`,
  }),
})

export const appConfig: ApplicationConfig = {
  providers: [
    ToastService,
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    provideTranslateService(provideTranslation()),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.url],
        sendAccessToken: true,
      },
    }),
    { provide: OAuthStorage, useFactory: oauthStorageFactory },
  ],
}
